import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import './AllMenuContainer.scss';
import { cn } from '@module/lib/utils';
interface Props {
  children: React.ReactNode;
  isbottom?: boolean;
  title: string;
  isFavorite?: boolean;
}
export function AllMenuContainer(t0) {
  const $ = _c(13);
  const {
    children,
    isbottom: t1,
    title,
    isFavorite: t2
  } = t0;
  const isbottom = t1 === undefined ? false : t1;
  const isFavorite = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== isbottom) {
    t3 = cn("all-menu-container text-colorFg01", {
      "border-borderBg08 border-b": isbottom
    });
    $[0] = isbottom;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== title) {
    t4 = title && <div className="title ">{title}</div>;
    $[2] = title;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== isFavorite) {
    t5 = cn("list", {
      "border-borderBg08 border-b pt-[12px] pb-[8px]": isFavorite
    });
    $[4] = isFavorite;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== children || $[7] !== t5) {
    t6 = <div className={t5}>{children}</div>;
    $[6] = children;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t6) {
    t7 = <div className={t3}>{t4}{t6}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}